import BaseRepository from '../../../baseRepository/BaseRepository';
const resource = `/api/v1/shared/typemodels`;

export default {
  getEnums(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/enums`, {
      baseURL,
      headers,
      params,
    });
  },
  getEnum(name, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/enums/${name}`, {
      baseURL,
      headers,
      params,
    });
  },
  getModel(name, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${name}`, {
      baseURL,
      headers,
      params,
    });
  },
};
